<template>
	<nav class="menu" :id="id" :class="clazz">
		<div class="menu-header" v-if="hasHeader">
			<span class="menu-title"><sym-icon v-if="group.icon" :name="group.icon" class="menu-fi"></sym-icon>{{ group.title }}</span>
			<span><template v-if="!!group.action">
				<it-link v-if="group.action.link" :to="group.action.link" @click="executeTitleAction"><sym-icon :name="group.action.icon" class="title-action" v-bind="titleActionBind"></sym-icon></it-link>
				<icon-button v-else :name="group.action.icon" class="title-action" v-bind="titleActionBind" @click="executeTitleAction"></icon-button>
			</template>
			<more-opener v-if="group.open !== 'always-open'" v-model="opened"></more-opener></span>
		</div>
		<show-down class="menu-body" :show="opened || !hasHeader || !!group.action">
			<side-bar-menu-item v-for="item of group.items" :item="item" :key="item.name"></side-bar-menu-item>
		</show-down>
	</nav>
</template>

<script setup lang="ts">
import type {MenuGroup} from "@t/ui/Menu";
import {computed, ref, watch} from "vue";
import SideBarMenuItem from "./SideBarMenuItem.vue";
import ShowDown from "@fd/helpers/ShowDown.vue";
import MoreOpener from "@fd/helpers/MoreOpener.vue";
import SymIcon from "@fd/helpers/SymIcon.vue";
import ItLink from "@/router/ItLink.vue";
import IconButton from "@fd/helpers/IconButton.vue";

const props = defineProps<{
	group: MenuGroup
}>();

const id = computed<string>(() => "smg_"+props.group.name);
const clazz = computed<string[]>(() => {
	const c = [];
	if (props.group.clazz) c.push(props.group.clazz);
	if (!opened.value) c.push("menu-closed");
	return c;
});
const opened = ref<boolean>(openDefault());
const hasHeader = computed<boolean>(() => typeof props.group.title === 'string' && props.group.title.length > 0);

function openDefault() {
	if (props.group.open === 'always-open') return true;
	const saved = localStorage.getItem(props.group.name);	// possible values are: "display", "none"
	if (typeof saved === "string") {
		return "display" === saved;
	}
	return props.group.open !== 'closed';
}

const titleActionBind = computed(() => {
	const b:any = {};
	if (props.group.action && props.group.action.title) {
		b.title = props.group.action.title;
	}
	return b;
});

function executeTitleAction() {
	if (props.group?.action?.onclick) {
		alert("JS execution not yet implemented");
	}
}


watch(opened, (newValue) => {
	localStorage.setItem(props.group.name, newValue ? "display" : "none");
});
</script>

<style>
.title-action {
	cursor: pointer;
	opacity: 0.5;

	&:hover {
		opacity: 1;
	}
}
</style>